import React from 'react'
import { Link } from 'react-router-dom'

const Topbar = () => {
    return (
        <>
            <div id="top-bar-two" className="top-bar-two-main-block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <ul className="top-bar-two-order-dtls text-center text-md-center text-lg-start">
                                <li>
                                    <Link to="#" title="">
                                        Store Locations
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" title="">
                                        Order Tracking
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="top-bar-two-offer text-center">
                                <p>Summer Sale Discount on 40%</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <ul className="top-bar-two-social-icons text-center text-md-end text-lg-end">
                                <li>
                                    <Link to="#" title="">
                                        <i className="flaticon-facebook" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" title="">
                                        <i className="flaticon-twitter" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" title="" />
                                    <i className="flaticon-linkedin" />
                                </li>
                                <li>
                                    <Link to="#" title="">
                                        <i className="flaticon-pinterest" />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Topbar
